/**
 * bs-tempest (พายุป่าไผ่) live: the FX-PORT set piece (sampleArt/arts/breeze.ts `tempest`) turned on for this move only and
 * timed to the rules' beats (packages/shared data/longMoves/breezeSword.ts) instead of its own page clock: the gather over
 * the 0.7 s tell, the release on the uproot's blow, its four dashes on the three passes' blows and the leap's first cut,
 * the leaves drawn up over the quiet beat, the climax on the dive's blow, the aftermath over the kneel and the release.
 * The afterimages come from the beats' `ai` (render/longMove.ts), so the sample's own are left out.
 */
import { longMoveOf } from '@nine/shared';
import { blowTimes, longRetime } from '../longMove';
import { registerFx } from './registry';
import { portOf } from './sampleArt/port';

registerFx([], (host) => {
  const def = longMoveOf('bs-tempest');
  const spec = portOf('bs-tempest');
  if (!def || !spec) return {};
  const at = (pose: string) => def.beats.findIndex((b) => b.pose === pose);
  const blow = (pose: string) => blowTimes(def, at(pose))[0]!;
  // [piece s, sample s]: the sample's beats (T_REL 1.2, T_DASH 1.5/1.85/2.2/2.55, T_CLIMAX 3.0, aftermath 3.3, end 4.4).
  const anchors: [number, number][] = [
    [-def.opener.tell, 0.05],
    [blow('tpUproot'), 1.2],
    [blow('tpPassA'), 1.5],
    [blow('tpPassB'), 1.85],
    [blow('tpPassC'), 2.2],
    [blow('tpRise'), 2.55],
    [def.beats[at('tpGather')]!.at, 2.8],
    [blow('tpDive'), 3.0],
    [def.beats[at('tpKneel')]!.at, 3.3],
    [def.len, spec.end],
  ];
  spec.on = true;
  spec.ghosts = undefined;
  spec.retime = longRetime(host.world, 'bs-tempest', anchors, spec.end);
  return {};
});
